import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { Redirect } from "react-router-dom";

function PrivateRouteComponent({
  component: Component,
  user,
  roleFor,
  ...rest
}) {
  return (
    <Route
      {...rest}
      render={(props) => {
        return (user && !user.token) ||
          !user ||
          (roleFor && user && user.role !== roleFor) ? (
          <Redirect to="/login" />
        ) : (
          <Component {...props} />
        );
      }}
    />
  );
}

const PrivateRoute = PrivateRouteComponent;

export default PrivateRoute;
